import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { FormTypesData } from '../domains/common.domain';
import { CheckServiceAvailabilityData, CheckServiceAvailabilityResponse } from './jurisdiction.domain';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EnvironmentService } from '../services/environment.service';

@Injectable()
export class JurisdictionService {
  private messageSource = new BehaviorSubject(false);
  private isPower = new BehaviorSubject(true);
  private meterInstallation = new BehaviorSubject('1');
  private thirdPartyAffectedValue: string = '0';
  private isApplicantLandownerValue: boolean = true;
  private isInterestInFibreOpticsValue: boolean = false;
  private powerValue: string;

  constructor(private http: HttpClient, private environment: EnvironmentService) {}

  get thirdPartyAffected(): string {
    return this.thirdPartyAffectedValue;
  }

  set thirdPartyAffected(value: string) {
    this.thirdPartyAffectedValue = value;
  }

  get isApplicantLandowner(): boolean {
    return this.isApplicantLandownerValue;
  }

  set isApplicantLandowner(value: boolean) {
    this.isApplicantLandownerValue = value;
  }

  get isInterestInFibreOptics(): boolean {
    return this.isInterestInFibreOpticsValue;
  }

  set isInterestInFibreOptics(value: boolean) {
    this.isInterestInFibreOpticsValue = value;
  }

  fetchNewDevAreaMessage(): Observable<boolean> {
    return this.messageSource.asObservable();
  }

  newDevAreaMessage(message: boolean) {
    this.messageSource.next(message);
  }

  setPowerType(power: string) {
    this.powerValue = power;
  }

  setMediaType(mediaType: string): Observable<boolean> {
    if (this.powerValue !== 'device_shutdown' || mediaType !== 'power') {
      this.isPower.next(true);
      return this.isPower.asObservable();
    } else {
      this.isPower.next(false);
      return this.isPower.asObservable();
    }
  }

  getMeterInstallation(): Observable<string> {
    return this.meterInstallation.asObservable();
  }

  setMeterInstallation(message: string) {
    this.meterInstallation.next(message);
  }

  setCurrentFormType(currentFormType: FormTypesData, selectedFacilityTypes: FormTypesData[]): FormTypesData {
    let selectedIndex = 0;

    if (!currentFormType) {
      currentFormType = selectedFacilityTypes[selectedIndex];
    } else {
      selectedFacilityTypes.forEach((item, i) => {
        if (item.index === currentFormType.index) {
          selectedIndex = i;
        }
      });
      currentFormType = selectedFacilityTypes[selectedIndex + 1];
    }

    return currentFormType;
  }

  checkServiceAvailability(requestData: CheckServiceAvailabilityData): Observable<CheckServiceAvailabilityResponse> {
    let params = new HttpParams().append('medium', requestData.medium);

    if (requestData.sk_development_area_type) {
      params = params.append('devarea', requestData.sk_development_area_type);
      params = params.append('developmentArea', requestData.development_area_name);
    } else if (requestData.x && requestData.y) {
      params = params.append('x', requestData.x.toString()).append('y', requestData.y.toString());
    } else {
      params = requestData.city ? params.append('city', requestData.city) : params;
      params = requestData.district ? params.append('district', requestData.district) : params;
      params = requestData.street ? params.append('street', requestData.street) : params;
      params = requestData.street_number ? params.append('street_number', requestData.street_number) : params;
    }

    params = requestData.zipcode ? params.append('zipcode', requestData.zipcode) : params;

    const url = `${this.environment.apiUrl}regionalstructure`;

    return this.http.get<CheckServiceAvailabilityResponse>(url, { params });
  }
}
